/**
 * GlobalFilters
 */
import * as React from 'react';

// Components
// @ts-ignore
import SeasonDropdown from '../../../SeasonDropdown';
import EntityTypeEntityDropdowns from '../../../EntityTypeEntityDropdowns';

// Styles
import './styles.scss';

interface Props {
    currentEntity?: boolean;
    currentSeason?: boolean;
}

export default class GlobalFilters extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { currentEntity, currentSeason } = this.props;

        if (!currentEntity && !currentSeason) return null;

        return (
            <span className="global-filters">
                <strong>Viewing data from: </strong>
                {currentSeason && <SeasonDropdown direction="left" inline />}
                {currentEntity && (
                    <EntityTypeEntityDropdowns
                        limit={1}
                        offset={0}
                        direction="left"
                        inline
                    />
                )}
            </span>
        );
    }
}
